/**
 * Adds a `css` method to the Array prototype if it doesn't already exist.
 *
 * The `css` method joins array elements into a single space-separated string,
 * trims any leading or trailing whitespace, and returns `null` if the result is an empty string.
 *
 * Example usage:
 * ```js
 * const classes = ['btn', 'btn-primary', '', 'active'];
 * console.log(classes.css()); // "btn btn-primary active"
 *
 * const emptyClasses = ['', ' '];
 * console.log(emptyClasses.css()); // null
 * ```
 *
 * @returns {string|null} The space-separated string of array elements, or `null` if empty.
 */
if (!Array.prototype.css) {
  // eslint-disable-next-line no-extend-native
  Object.defineProperty(Array.prototype, 'css', {
    value() {
      const trimmed = this.join(' ').trim();

      return trimmed === '' ? null : trimmed;
    },
    writable: true,
    configurable: true,
    enumerable: false,
  });
}
